import { ReactNode, useState } from "react";
import { SvgIcon } from "@mui/material";
import { CoreIconButton } from "@verity/components/core";
import i18n from "../../i18n";
import styles from "./portal-banner.module.css";
import Close from "../../images/portal/cross-x.svg?react";

export default function PortalBanner({
	onClose,
	children,
	className,
	style,
}: {
	onClose?: () => void;
	children: ReactNode;
	className?: string;
	style?: React.CSSProperties;
}) {
	const [closed, setClosed] = useState(false);

	const handleClose = () => {
		setClosed(true);
		setTimeout(() => onClose?.(), 300);
	};

	return (
		<div
			className={`${styles.portalBanner} ${closed ? styles.portalBannerClosed : ""} ${className || ""}`}
			style={style}
		>
			<div className={styles.portalBannerChildren}>{children}</div>
			{onClose && (
				<CoreIconButton
					variant="plain"
					onClick={handleClose}
					tooltip={i18n.t("portal.components.portalBannerTSX.close")}
				>
					<SvgIcon>
						<Close />
					</SvgIcon>
				</CoreIconButton>
			)}
		</div>
	);
}
